import { getColorScheme } from '../../colors';
import { verticalPillsBottomMargin, horizontalPillsRightMargin, verticalPointingBottomMargin } from './menuItemStyles';
export var menuDividerStyles = {
  root: function root(_ref) {
    var _Object$assign;

    var p = _ref.props,
        v = _ref.variables;
    var colors = getColorScheme(v.colorScheme, null, p.primary);
    var borderColor = p.primary ? v.primaryBorderColor : v.borderColor || colors.border;
    var borderType = p.vertical ? 'borderTop' : 'borderLeft';
    return Object.assign({}, p.pointing && p.vertical && {
      marginBottom: verticalPointingBottomMargin
    }, p.pills && Object.assign({}, p.vertical ? {
      margin: "0 0 " + verticalPillsBottomMargin + " 0"
    } : {
      margin: "0 " + horizontalPillsRightMargin + " 0 0"
    }), p.hasContent ? {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center'
    } : Object.assign((_Object$assign = {}, _Object$assign[borderType] = "1px solid " + borderColor, _Object$assign), !p.vertical && {
      alignSelf: 'stretch'
    }, p.vertical && p.inSubmenu && {
      margin: '8px 0'
    }));
  }
};